import { alpha } from "@mui/material";

const styles = (theme) => ({
  dialogPaper: {
    borderRadius: "16px",
  },
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 2,
  },
  titulo: {
    fontSize: "18px",
    fontWeight: 600,
  },
  erpRow: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    mt: 0.5,
  },
  erpLabel: {
    fontSize: "0.8rem",
    color: theme.palette.text.secondary,
  },
  chipErp: {
    fontWeight: 600,
    bgcolor: alpha(theme.palette.primary.main, 0.12),
    color: theme.palette.primary.main,
    "& .MuiChip-icon": { color: theme.palette.primary.main, fontSize: "16px" },
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: 2.5,
    "&.MuiDialogContent-root": { pt: 1 },
  },
  grupo: {
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
  },
  grupoTitulo: {
    fontWeight: 600,
    fontSize: "0.85rem",
    pb: 0.5,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  grid: {
    display: "grid",
    gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))" },
    gap: 2,
  },
  campoLargo: {
    gridColumn: "1 / -1",
  },
  actions: {
    padding: theme.spacing(2, 3, 3),
    gap: 1,
  },
  aviso: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    mr: "auto",
  },
  avisoIcone: {
    fontSize: "16px",
    color: theme.palette.text.secondary,
  },
  avisoTexto: {
    fontSize: "0.75rem",
    color: theme.palette.text.secondary,
  },
});

export default styles;
